import { createToken } from '@core/utils/ioc';
import { UserBloc } from './user_bloc';
import { CompanyBloc } from './company_bloc';
import { BrandBloc } from './brand_bloc';
import { AdminScaleBloc } from './admin_scale_bloc';
import { AdminScaleChildBloc } from './admin_scale_child_bloc';
import { CompanyPolicyBloc } from './company_policy_bloc';
import { SeriesBloc } from './series_bloc';
import { LibraryBloc } from './library_bloc/LibraryBloc';
import { UserCourseBloc } from './user_course_bloc';
import { CourseBloc } from './course_bloc';
import { PreviewCourseBloc } from './preview_course_bloc';
import { ProgramsBloc } from './programs_bloc';
import { ProgramChildBloc } from './program_child_bloc';
import { ProgramTargetBloc } from './program_target_bloc';
import { ProgramDiscussBloc } from './program_discuss_bloc';
import { BattlePlanSectionBloc } from './battle_plan_section_bloc';
import { BattlePlanSectionTaskBloc } from './battle_plan_section_task_bloc';
import { BattlePlanTaskCommentBloc } from './battle_plan_task_comment_bloc';
import { GraphBloc } from './graph_bloc';
import { TaskStatusBloc } from './task_statuses';
import { ProgramSectionBloc } from './program_section_bloc';
import { GraphGroupBloc } from './graph_group_bloc';
import { GroupBloc } from './group_bloc';
import { GroupUserBloc } from './group_user_bloc';
import { FormBloc } from './form_bloc';
import { StatCollectionBloc } from './stat_collection_bloc';
import { ReportBloc } from './report_bloc';
import { BatchBloc } from './batch_bloc';
import { ManagementFormTemplateBloc } from './management_form_template_bloc';
import { ManagementFormBloc } from './management_form_bloc';
import { OrgBoardBloc } from './org_board';
import { OrgBoardRevisionBloc } from './org_board/OrgBoardRevisionBloc';
import { GraphOverlayBloc } from './graph_overlay_bloc';
import { SummaryBloc } from './summary_bloc';
import { OrgBoardChildBloc } from './org_board/OrgBoardChildBloc';
import { TopMenuBloc } from './top_menu_bloc';
import { SiteSettingBloc } from './site_setting_bloc/SiteSettingBloc';
import { HcaLibraryBloc } from './hca_library';
import { CourseInboxBloc } from './instructor_inbox_bloc';
import { CourseInboxReplyBloc } from './course_inbox_reply_bloc';
import { SettingsBloc } from './settings_bloc';
import { GraphConditionBloc } from './graph_condition_bloc';
import { NoteBloc } from './note_bloc';
import { HelpArticleBloc } from './help_article_bloc';
import { HelpArticleCategoryBloc } from './help_article_category_bloc';
import { HelpArticleTagBloc } from './help_article_tag_bloc';
import { IdeaBloc } from './idea_bloc';
import { KnowledgeBaseBloc } from './knowledge_base_bloc';
import { ClientBloc } from './client_bloc';
import { GlossaryBloc } from './glossary_bloc';

export const Blocs = {
  settings: createToken<SettingsBloc>(),
  user: createToken<UserBloc>(),
  compnay: createToken<CompanyBloc>(),
  brand: createToken<BrandBloc>(),
  adminScale: createToken<AdminScaleBloc>(),
  adminScaleChild: createToken<AdminScaleChildBloc>(),
  companyPolicyBloc: createToken<CompanyPolicyBloc>(),
  series: createToken<SeriesBloc>(),
  library: createToken<LibraryBloc>(),
  userCourse: createToken<UserCourseBloc>(),
  course: createToken<CourseBloc>(),
  previewCourse: createToken<PreviewCourseBloc>(),
  programs: createToken<ProgramsBloc>(),
  programChild: createToken<ProgramChildBloc>(),
  programTarget: createToken<ProgramTargetBloc>(),
  programDiscuss: createToken<ProgramDiscussBloc>(),
  battlePlanSection: createToken<BattlePlanSectionBloc>(),
  battlePlanSectionTask: createToken<BattlePlanSectionTaskBloc>(),
  battlePlanTaskComment: createToken<BattlePlanTaskCommentBloc>(),
  graph: createToken<GraphBloc>(),
  graphCondition: createToken<GraphConditionBloc>(),
  taskStatus: createToken<TaskStatusBloc>(),
  programSection: createToken<ProgramSectionBloc>(),
  graphGroup: createToken<GraphGroupBloc>(),
  group: createToken<GroupBloc>(),
  groupUser: createToken<GroupUserBloc>(),
  form: createToken<FormBloc>(),
  statCollection: createToken<StatCollectionBloc>(),
  report: createToken<ReportBloc>(),
  statBatch: createToken<BatchBloc>(),
  managementFormTemplates: createToken<ManagementFormTemplateBloc>(),
  managementForm: createToken<ManagementFormBloc>(),
  orgBoard: createToken<OrgBoardBloc>(),
  orgBoardChild: createToken<OrgBoardChildBloc>(),
  orgBoardRevision: createToken<OrgBoardRevisionBloc>(),
  overlayGraph: createToken<GraphOverlayBloc>(),
  summary: createToken<SummaryBloc>(),
  topMenu: createToken<TopMenuBloc>(),
  siteSetting: createToken<SiteSettingBloc>(),
  hcaLibrary: createToken<HcaLibraryBloc>(),
  courseInbox: createToken<CourseInboxBloc>(),
  courseInboxReply: createToken<CourseInboxReplyBloc>(),
  noteBloc: createToken<NoteBloc>(),
  helpArticle: createToken<HelpArticleBloc>(),
  helpArticleCategory: createToken<HelpArticleCategoryBloc>(),
  helpArticleTag: createToken<HelpArticleTagBloc>(),
  idea: createToken<IdeaBloc>(),
  knowledgeBase: createToken<KnowledgeBaseBloc>(),
  client: createToken<ClientBloc>(),
  glossary: createToken<GlossaryBloc>(),
};
